let popUpLinks: NodeList | null;

const popUpHeight = 600;
const popUpWidth = 960;

export function initPopUp() {
    popUpLinks = <NodeList>document.querySelectorAll('[data-popup]');
    Array.prototype.forEach.call(popUpLinks, (item: HTMLAnchorElement) => {
        addClickListener(item as HTMLAnchorElement);
    });
}

function addClickListener(item: HTMLAnchorElement) {
    item.addEventListener('click', function (e: MouseEvent) {
        e.preventDefault();

        let href = item.href;
        let popUpLeft = (screen.width/2)-(popUpWidth/2);
        let popUpTop = (screen.height/2)-(popUpHeight/2);

        window.open(href, "_blank", "toolbar=no,scrollbars=no,resizable=yes,top=" + popUpTop + ", left=" + popUpLeft +  ", width=" + popUpWidth + ", height=" + popUpHeight);
    });
}


 